import { loadStripe } from '@stripe/stripe-js';

const STRIPE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
const STRIPE_MODE = import.meta.env.VITE_STRIPE_MODE || 'test';

if (!STRIPE_KEY) {
  throw new Error('Missing Stripe publishable key. Please check your environment variables.');
}

// Initialize Stripe with error handling
let stripeInstance = null;
export const stripePromise = (async () => {
  try {
    stripeInstance = await loadStripe(STRIPE_KEY);
    if (!stripeInstance) {
      throw new Error('Failed to initialize Stripe');
    }
    return stripeInstance;
  } catch (error) {
    console.error('Error initializing Stripe:', error);
    throw error;
  }
})();

// Price IDs for different environments
const PRICE_IDS = {
  test: {
    FREE: 'free',
    LIFETIME: 'price_1RGW8tI3G1M8PMhO0LK7rYRC'
  },
  live: {
    FREE: 'free',
    LIFETIME: 'price_1RElDTI3G1M8PMhOHWThb2gv'
  }
} as const;

export const STRIPE_PRICES = PRICE_IDS[STRIPE_MODE as keyof typeof PRICE_IDS];

export type SubscriptionTier = keyof typeof STRIPE_PRICES;

export interface PricingTier {
  name: string;
  price: number | null;
  currency: string;
  features: string[];
  priceId: string;
  description: string;
  popular?: boolean;
}

export const PRICING_TIERS: Record<SubscriptionTier, PricingTier> = {
  FREE: {
    name: 'Free',
    price: null,
    currency: 'AUD',
    priceId: STRIPE_PRICES.FREE,
    description: 'Perfect for trying out WAFManager Pro',
    features: [
      'Up to 10 domains',
      '1 Cloudflare account',
      'Core WAF templates',
      'Basic DNS management',
      'Community support'
    ]
  },
  LIFETIME: {
    name: 'Lifetime',
    price: 99,
    currency: 'AUD',
    priceId: STRIPE_PRICES.LIFETIME,
    description: 'One-time payment for unlimited access',
    popular: true,
    features: [
      'Unlimited domains',
      'Unlimited Cloudflare accounts',
      'All WAF templates',
      'Advanced DNS management',
      'Priority email support',
      'Bulk operations',
      'Custom templates',
      'Team management',
      'Free updates forever'
    ]
  }
};